const initialState = {
    loading: false,
    modal: -1,
    customers: [],
    logs: [],
    total: 0,
    delStatus: undefined
}

const selfParkingReducer = (state = initialState, action) => {
    switch (action.type) {
        case "INIT":
            return {
                ...state,
                loading: true
            }
        case "ADD_STAFF_SUCCESS":
            state.customers.unshift(action.staff)
            return { ...state, loading: false, modal: 0 }
        case "ADD_STAFF_FAILED":
            return {
                ...state,
                loading: false,
                modal: 1
            }
        case "GET_SELF_CUSTOMERS":
            return {
                ...state,
                customers: action.customers,
                total: action.total
            }
        case "UPDATE_STAFF_SUCCESS":
            let newState = {...state}
            newState.customers.splice(action.index, 1, action.staff);
            return {
                ...state,
                loading: false,
                modal: 0
            }
        case "DELETE_CUSTOMER":
            return {
                ...state,
                delStatus: -1
            }
        case "DELETE_CUSTOMER_SUCCESS":
            let originState = {...state}
            originState.customers.splice(action.index, 1);
            return {
                ...state,
                delStatus: 1
            }
        case "DELETE_CUSTOMER_FAILED":
            return {
                ...state,
                delStatus: 0
            }
        default:
            return state
    }
}

export default selfParkingReducer
